import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Report from '../../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ComplianceReceptacleIdVsDespatchIdSubclassMismatchSelectors';

export function ComplianceReceptacleIdVsDespatchIdSubclassMismatchContainer(props) {
  return (
    <Report
      reportId={ReportDefinitions.MISMATCHED_SUBCLASS_RECEPTACLE_ID_VS_DESPATCH_ID.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ComplianceReceptacleIdVsDespatchIdSubclassMismatchContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ComplianceReceptacleIdVsDespatchIdSubclassMismatchContainer);
